/**
 * Dasboard Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncOrdersDashboardComponent,
} from "Components/AsyncComponent/AsyncComponent";

const Dashboard = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/orders`} />
      <Route
        path={`${match.url}/orders`}
        component={AsyncOrdersDashboardComponent}
      />
    </Switch>
  </div>
);

export default Dashboard;
